export const formatFetchableQuery = q => {
	const {user, ...query} = q;

	if (user) {
		query.userId = user.id;
	}

	return query;
};
